export default __webpack_public_path__ + "static/media/logo_color.dc2352ff.png";